import { createContext, useContext } from "react";
import { useState } from "react";
import { useImmer } from "use-immer";
const confirmContext = createContext(null);
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@emotion/react";
export const useSnackBarContext = () => useContext(confirmContext);

//provider for snackbar

const initialState = {
  open: false,
  message: "",
  isError: false,
  dialogTitle: "Heading",
  dialogText: "Text",
  disagreeButton: "Disagree",
  agreeButton: "Accept",
};
export const ConfirmContextWrapper = ({ children }) => {
  const [state, updateState] = useImmer(initialState);

  const confirm = async ({ dialogText, dialogTitle }) => {
    updateState((draft) => {
      draft.dialogText = dialogText;
      draft.dialogTitle = dialogTitle;
    });
  };
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    updateState((draft) => {
      draft.open = true;
    });
  };

  const handleClose = (accepted) => {
    updateState((draft) => {
      return initialState;
    });
  };
  return (
    <confirmContext.Provider value={{}}>
      {/* <Button variant="outlined" onClick={handleClickOpen}>
        Open responsive dialog
      </Button>
      <Dialog
        fullScreen={fullScreen}
        open={state.open}
        onClose={() => handleClose(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {state.dialogTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>{state.dialogText}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={() => handleClose(false)}>
            Disagree
          </Button>
          <Button onClick={() => handleClose(true)} autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog> */}
      {children}
    </confirmContext.Provider>
  );
};
